import { render } from "./StakeInfoModal.vue?vue&type=template&id=7b86559e&scoped=true&ts=true"
import script from "./StakeInfoModal.vue?vue&type=script&lang=ts"
export * from "./StakeInfoModal.vue?vue&type=script&lang=ts"

import "./StakeInfoModal.vue?vue&type=style&index=0&id=7b86559e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b86559e"]])

export default __exports__